import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigationType } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "@/context/StoreContext";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import BundlePage from "@/pages/BundlePage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CartPage from "@/pages/CartPage";
import WishlistPage from "@/pages/WishlistPage";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import ShippingPolicy from "@/pages/ShippingPolicy";
import RefundPolicy from "@/pages/RefundPolicy";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileCartBar from "@/components/MobileCartBar";
import FloatingSummer from "@/components/FloatingSummer";
import CartDrawer from "@/components/CartDrawer";
// Exposes window.testFastrrCheckout for Shiprocket support team verification
import "@/lib/shiprocket";

// New page → start at top; Back/Forward keeps browser position
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType !== "POP") window.scrollTo(0, 0);
  }, [pathname, navType]);
  return null;
};

function App() {
  return (
    <div className="gg-root min-h-screen bg-cream text-plum relative">
      <StoreProvider>
        <BrowserRouter>
          <ScrollToTop />
          <FloatingSummer count={10} />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/bundle/:slug" element={<BundlePage />} />
              {/* Legacy BOGO redirects → new bundles */}
              <Route path="/shop/b1g1" element={<BundlePage />} />
              <Route path="/shop/b1g2" element={<BundlePage />} />
              <Route path="/product/:id" element={<ProductDetailPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/wishlist" element={<WishlistPage />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/policy/shipping" element={<ShippingPolicy />} />
              <Route path="/policy/refund" element={<RefundPolicy />} />
              <Route path="/policy/privacy" element={<PrivacyPolicy />} />
              <Route path="/policy/terms" element={<TermsOfService />} />
            </Routes>
          </main>
          <Footer />
          <MobileCartBar />
          <CartDrawer />
          <Toaster
            position="bottom-right"
            theme="light"
            toastOptions={{
              style: {
                background: "#FDF6F0",
                color: "#4A2C35",
                border: "1px solid #FBEAF0",
                fontFamily: "DM Sans, sans-serif",
              },
            }}
          />
        </BrowserRouter>
      </StoreProvider>
    </div>
  );
}

export default App;
